import React, { useEffect, useState } from "react";
import api, { formatINR } from "../lib/api";
import { ExternalLink, FileText, Download } from "lucide-react";

/** Read-only list of files that staff uploaded against this user's account. */
export default function MyExternalInvoices({ heading = "Uploaded invoices", showEmpty = false }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/me/external-invoices")
            .then((r) => setItems(r.data))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return null;
    if (items.length === 0 && !showEmpty) return null;

    const apiBase = (api.defaults.baseURL || "").replace(/\/api$/, "");

    return (
        <section data-testid="my-external-invoices">
            <h2 className="font-serif text-3xl text-slate-900 mb-3">{heading}</h2>
            <p className="text-sm text-stone-500 mb-4">Bills uploaded by HPL staff. Click to view or download.</p>
            {items.length === 0 ? (
                <p className="text-sm text-stone-500">Nothing here yet.</p>
            ) : (
                <div className="bg-white border border-sky-100 overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead><tr className="bg-sky-50 border-b border-sky-100">
                            <th className="text-left p-3 text-xs uppercase tracking-widest text-stone-500">Invoice #</th>
                            <th className="text-left p-3 text-xs uppercase tracking-widest text-stone-500">File</th>
                            <th className="text-right p-3 text-xs uppercase tracking-widest text-stone-500">Amount</th>
                            <th className="text-left p-3 text-xs uppercase tracking-widest text-stone-500">Uploaded</th>
                            <th className="text-right p-3"></th>
                        </tr></thead>
                        <tbody>
                            {items.map((inv) => (
                                <tr key={inv.id} className="border-b border-stone-100" data-testid={`my-ext-${inv.id}`}>
                                    <td className="p-3 font-mono">{inv.invoice_number}</td>
                                    <td className="p-3 text-stone-700"><FileText className="w-3.5 h-3.5 inline mr-1" />{inv.file_name}</td>
                                    <td className="p-3 text-right">{inv.amount != null ? formatINR(inv.amount) : "—"}</td>
                                    <td className="p-3 text-stone-500 text-xs">{new Date(inv.created_at).toLocaleString()}</td>
                                    <td className="p-3 text-right space-x-3 whitespace-nowrap">
                                        <a href={`${apiBase}${inv.file_url}`} target="_blank" rel="noreferrer" className="text-sky-700 hover:text-sky-800 inline-flex items-center text-xs underline">
                                            <ExternalLink className="w-3.5 h-3.5 mr-1" />View
                                        </a>
                                        <a href={`${apiBase}${inv.file_url}`} download={inv.file_name} className="text-stone-700 hover:text-stone-900 inline-flex items-center text-xs underline">
                                            <Download className="w-3.5 h-3.5 mr-1" />Download
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </section>
    );
}
